import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { useTitleRampNames } from '../../../shared/useTitleRampNames';
export var TableHeaderTitleBase = function () {
    var _a = useTitleRampNames('TitleCellContainer', 'HeaderTitleCellContainer'), containerRampName = _a.rampName, containerRampFallbacks = _a.rampFallbacks;
    var _b = useTitleRampNames('TitleCellContent', 'HeaderTitleCellContent'), contentRampName = _b.rampName, contentRampFallbacks = _b.rampFallbacks;
    return (React.createElement(RampWithNameTransform, { rampName: containerRampName, rampFallbacks: containerRampFallbacks },
        React.createElement(RampWithNameTransform, { rampName: contentRampName, rampFallbacks: contentRampFallbacks })));
};
